import React from 'react'
import AppStoreLink from "@Sidebar/components/AppStoreNotice/AppStoreLink";
import Row from "@Containers/components/Row";
import Column from "@Containers/components/Column";
import useSingleTrackingEvent from "@Events/hooks/useSingleTrackingEvent";
import ClickAppBannerEventModel from "@Events/models/ClickAppBannerEventModel";
import useDispatchAppBannerEvent from "@SearchResults/features/sidebar/hooks/useDispatchAppBannerEvent";

interface AppStoreLinksContainerProps {
    direction?: string,
    className?: string
}

const AppStoreLinksContainer = ({direction, className}: AppStoreLinksContainerProps) => {

    const handleOnClick = useDispatchAppBannerEvent(className)

    if (direction === "column") {
        return (
            <Column wrap className={className}>
                <AppStoreLink
                    link={window.appStoreUrl}
                    filePath="images/icons/appstore/appstore-ico-us"
                    fileType="svg"
                    className="app-store-link"
                    handleOnClick={handleOnClick}
                />
                <AppStoreLink
                    link={window.googleStoreUrl}
                    filePath="images/icons/googlestore/google-play-ico-en"
                    fileType="svg"
                    className="google-play-link"
                    handleOnClick={handleOnClick}
                />
            </Column>
        )
    }
    return (
        <Row center gap className={className}>
            <AppStoreLink
                link={window.appStoreUrl}
                filePath="images/icons/appstore/appstore-ico-us"
                fileType="svg"
                className="app-store-link"
                handleOnClick={handleOnClick}
            />
            <AppStoreLink
                link={window.googleStoreUrl}
                filePath="images/icons/googlestore/google-play-ico-en"
                fileType="svg"
                className="google-play-link"
                handleOnClick={handleOnClick}
            />
        </Row>
    )
}

export default AppStoreLinksContainer